// removed by extract-text-webpack-plugin
module.exports = {"statusContainer":"DisplayNameCell-statusContainer","trialContainer":"DisplayNameCell-trialContainer","trialText":"DisplayNameCell-trialText"};